module.exports = __webpack_public_path__ + "img/registration-image.5fe624c1.jpg";